/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _components = require('components');

/* eslint id-length: 0 */

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var TheDrip = (function (_Component) {
	_inherits(TheDrip, _Component);

	function TheDrip() {
		_classCallCheck(this, _TheDrip);

		_Component.apply(this, arguments);
	}

	TheDrip.prototype.render = function render() {
		var _classNames;

		var styles = require('./TheDrip.css');

		var baseStyles = _classnames2['default']((_classNames = {}, _classNames[this.props.className] = this.props.className, _classNames[styles.Base] = !this.props.className, _classNames));

		/* Map articles from API to <article/> elements */
		var articleRoll = _lodash2['default'].map(this.props.articles, function (article) {
			var _classNames2;

			var contentStyles = _classnames2['default']((_classNames2 = {}, _classNames2[styles.Content] = article.images['bbrew-small'].length, _classNames2[styles['Content--wide']] = !article.images['bbrew-small'].length, _classNames2));

			return _react2['default'].createElement(
				'article',
				{ className: styles.Article, key: article.id },
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.Link, to: article.url },
					article.images['bbrew-small'].length && _react2['default'].createElement(
						'figure',
						{ className: styles.Figure },
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + article.images['bbrew-small'][0] })
					),
					_react2['default'].createElement(
						'div',
						{ className: contentStyles },
						_react2['default'].createElement(_components.MetaBar, { postDate: article.date }),
						_react2['default'].createElement(
							'header',
							{ className: styles.Header },
							_react2['default'].createElement('h1', { className: styles.Title, dangerouslySetInnerHTML: { __html: article.title } })
						)
					)
				)
			);
		});

		return _react2['default'].createElement(
			'section',
			{ className: baseStyles },
			_react2['default'].createElement(_components.HeaderTab, { icon: 'cup', title: 'The Drip', subhead: 'Your quick news fix', url: '/section/daily-drip' }),
			_react2['default'].createElement(
				'div',
				{ className: styles.Articles },
				articleRoll,
				_react2['default'].createElement(
					'footer',
					{ className: styles.Footer },
					_react2['default'].createElement(
						_reactRouter.Link,
						{ className: styles.FooterLink, to: '/section/daily-drip' },
						'More of The Drip'
					)
				)
			)
		);
	};

	_createClass(TheDrip, null, [{
		key: 'propTypes',
		value: {
			articles: _react.PropTypes.array,
			error: _react.PropTypes.string,
			loading: _react.PropTypes.bool,
			className: _react.PropTypes.string
		},
		enumerable: true
	}]);

	var _TheDrip = TheDrip;
	TheDrip = _reactRedux.connect(function (state) {
		return {
			articles: state.theDrip.data,
			articlesError: state.theDrip.error,
			articlesLoading: state.theDrip.loading
		};
	})(TheDrip) || TheDrip;
	return TheDrip;
})(_react.Component);

exports['default'] = TheDrip;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/TheDrip/TheDrip.js
 ** module id = 695
 ** module chunks = 0
 **/